import React, { PureComponent, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'

import Modal from '../../UniformComponents/Modal'
import Button from '../../UniformComponents/Button'
import Badge from '../../UniformComponents/Badge'
import Select from '../form/Select'
import FormController from '../form/FormController'

import './venue.scss'

@observer
class VenueEdit extends PureComponent {
    constructor(props) {
        super(props)
        this.fields = {}
        this.state = {
            deleting: false,
            venueToMap: null,
            showDeleteConfirm: false,
            curVenueId: 0,
        }
    }

    async componentDidUpdate(prevProps) {
        const {
            venueId, venueStore, handleCloseModal, showModal,
        } = this.props

        if (showModal && !prevProps.showModal) {
            await venueStore.initEdit(venueId, handleCloseModal)
            this.setState({ deleting: false, venueToMap: null, curVenueId: venueId })
        }
    }

    delete = async () => {
        const { venueStore, handleCloseModal } = this.props
        const {
            deleting, venueToMap, showDeleteConfirm, curVenueId,
        } = this.state

        if (deleting && R.isNil(venueToMap)) {
            // store.addNotification(null, 'Select venue to map', 'error')
        } else if (deleting && !showDeleteConfirm) {
            handleCloseModal()
            this.toggleConfirmDialog()
        } else if (deleting && showDeleteConfirm) {
            try {
                await venueStore.deleteVenue(curVenueId, venueToMap)
                // store.addNotification(null, 'Venue deleted', 'success')
            } catch (e) {
                // store.addNotification(null, 'Unable to delete venue', 'error')
            }
            this.toggleConfirmDialog()
            await venueStore.initSearch()
        } else {
            this.setState({
                deleting: true,
            })
        }
    }

    updateOrCreate = async () => {
        const {
            venueStore, handleCloseModal, venueId,
        } = this.props
        const { edit: { venue } } = venueStore

        const isValid = Object.keys(this.fields)
            .map((key) => this.fields[key]({
                value: venue[key],
                name: key,
            }, true))
            .every((valid) => valid)

        if (!isValid) return

        try {
            if (venueId === 0) {
                await venueStore.save(venue)
                // store.addNotification(null, 'Venue Added', 'success')
            } else {
                await venueStore.update(venue)
                // store.addNotification(null, 'Venue Updated', 'success')
            }
        } catch (e) {
            console.log(e)
            if (venueId === '0') {
                // store.addNotification(null, 'Unable to add venue', 'error')
            } else {
                // store.addNotification(null, 'Unable to update venue', 'error')
            }
        }

        handleCloseModal()
        await venueStore.initSearch()
    }

    onmap = (value) => {
        console.log('onmap', value)
        this.setState({
            venueToMap: value,
        })
    }

    toggleConfirmDialog = () => {
        const { showDeleteConfirm } = this.state
        this.setState({
            showDeleteConfirm: !showDeleteConfirm,
        })
    }

    renderSurveyCount = () => {
        const { venueId, venueStore } = this.props
        const { edit: { venue, surveyCount } } = venueStore

        if (venueId === 0) return null

        return (
            <div className="survey-count-wrapper">
                <Badge
                    type="success"
                    cssClass="count-status"
                    label={`Used in ${surveyCount} surveys`}
                    icon="fa-regular fa-circle-check"
                />
            </div>
        )
    }

    renderVenueMap = () => {
        const { deleting } = this.state
        const { venueStore } = this.props
        const { edit: { venues } } = venueStore

        if (deleting) {
            return (
                <div className="venue-map-wrapper">
                    <div className="info">
                        <i className="fa-solid fa-circle-info" />
                        <p>{i18n.t('venue.form.map.note')}</p>
                    </div>
                    <Select
                        label={i18n.t('venue.form.venueMap')}
                        options={venues}
                        isMandatory
                        onBlur={({ value }) => this.onmap(value)}
                        name="venueMap"
                    />
                </div>
            )
        }
        return null
    }

    renderButtons = () => {
        const { handleCloseModal, venueId } = this.props
        const { venueToMap, deleting } = this.state
        const showDelete = venueId !== 0
        return (
            <div className="form-button-wrapper">
                {showDelete ? (
                    <Button
                        label={i18n.t('delete')}
                        icon="fa-regular fa-user-xmark"
                        cssClass="regular tertiary"
                        onClick={this.delete}
                        disabled={deleting && !venueToMap}
                    />
                ) : (
                    <Button
                        label={i18n.t('close')}
                        icon=""
                        cssClass="regular tertiary"
                        onClick={handleCloseModal}
                    />
                )}
                <Button
                    label={i18n.t('save')}
                    icon="fa-light fa-floppy-disk"
                    cssClass="regular primary"
                    onClick={this.updateOrCreate}
                />
            </div>
        )
    }

    render() {
        const {
            venueId, showModal, handleCloseModal, venueStore,
        } = this.props
        const { showDeleteConfirm } = this.state

        return (
            <Fragment>
                <Modal
                    show={showModal}
                    onClose={handleCloseModal}
                    loading={venueStore.formLoading}
                >
                    <div className="form-header">
                        <h2>{venueId !== 0 ? i18n.t('venue.form.edit.title') : i18n.t('venue.form.add.title')}</h2>
                        <p className="desc">
                            {venueId !== 0 ? i18n.t('venue.form.edit.desc') : i18n.t('venue.form.add.desc')}
                        </p>
                    </div>
                    {this.renderSurveyCount()}
                    <FormController
                        fields={this.fields}
                        formFields={venueStore.formFields}
                        setField={venueStore.setField}
                    />
                    {this.renderVenueMap()}
                    {this.renderButtons()}
                </Modal>

                <Modal
                    show={showDeleteConfirm}
                    onClose={this.toggleConfirmDialog}
                >
                    <div className="form-header">
                        <h2>{i18n.t('gen_confirm_popup_title')}</h2>
                        <p className="desc">{i18n.t('venue.form.confirmDelete')}</p>
                    </div>
                    <div className="form-button-wrapper">
                        <Button
                            icon="fa-regular fa-xmark"
                            cssClass="regular primary"
                            label={i18n.t('gen_no')}
                            onClick={this.toggleConfirmDialog}
                        />
                        <Button
                            icon="fa-regular fa-check"
                            cssClass="regular tertiary"
                            label={i18n.t('gen_yes')}
                            onClick={this.delete}
                        />
                    </div>
                </Modal>
            </Fragment>
        )
    }
}

export default VenueEdit
